<template>
    <rkm-overlay>
        <rkm-layout-body title="Balancete">
            <template v-slot:actions>
                <rkm-button
                    v-if="additionals.dataBalanceteAberto"
                    :disabled="!additionals.permiteFechar"
                    :title="additionals.permiteFechar ? '' : 'Não é permitido fechar o balancete do mês atual.'"
                    @click="fecharBalancete()"
                    color="primary"
                >
                    Fechar balancete de {{ additionals.dataBalanceteAberto }}
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List
                    :key="listKey"
                    @additionals-load="additionals = $event"
                    @save="++listKey"
                    ref="List"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/almoxarifado/balancete/List'

export default {
    components: { List },
    data: () => ({
        listKey: 1,
        additionals: {},
    }),
    methods: {
        fecharBalancete() {

            this.showConfirmation(
                `Deseja realmente fechar o balancete de <strong>${this.additionals.dataBalanceteAberto}</strong>?`,
                async () => this.$refs.List.fecharBalancete()
            )
        },
    }
}
</script>